// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.spotlight.RentalManagerUserPropertySpotlightV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySpotlightV2WebApiHandler_apply,
  RentalManagerUserPropertySpotlightV2WebApiHandler_exclude,
  RentalManagerUserPropertySpotlightV2WebApiHandler_pin,
  RentalManagerUserPropertySpotlightV2WebApiHandler_reassign,
  RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization,
  RentalManagerUserPropertySpotlightV2WebApiHandler_remove,
  RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude,
  RentalManagerUserPropertySpotlightV2WebApiHandler_unpin,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ApplyListingSpotlightV2RequestDto,
  ExcludeListingSpotlightV2RequestDto,
  PinListingSpotlightV2RequestDto,
  ReassignListingSpotlightV2RequestDto,
  ReassignWithOptimizationListingSpotlightV2RequestDto,
  RemoveListingSpotlightV2RequestDto,
  UnexcludeListingSpotlightV2RequestDto,
  UnpinListingSpotlightV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Args {
  postData: ApplyListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Args
>;

/**
 * Apply listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_apply = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_apply_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_apply(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Args {
  postData: ExcludeListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Args
>;

/**
 * Exclude listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_exclude = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_exclude_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_exclude(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Args {
  postData: PinListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Args
>;

/**
 * Pin listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_pin = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_pin_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_pin(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Args {
  postData: ReassignListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Args
>;

/**
 * Reassign listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_reassign = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_reassign_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_reassign(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Args {
  postData: ReassignWithOptimizationListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Args
>;

/**
 * Reassign listing spotlight with optimization
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_reassignWithOptimization(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Args {
  postData: RemoveListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Args
>;

/**
 * Remove listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_remove = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_remove_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_remove(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Args {
  postData: UnexcludeListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Args
>;

/**
 * Unexclude listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_unexclude = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_unexclude(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Args {
  postData: UnpinListingSpotlightV2RequestDto;
}

export type RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Args
>;

/**
 * Unpin listing spotlight
 */
export const useRentalManagerUserPropertySpotlightV2WebApiHandler_unpin = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightV2WebApiHandler_unpin_Args) =>
      RentalManagerUserPropertySpotlightV2WebApiHandler_unpin(args.postData, httpClient),
  });
};
